export const isAutopilotUiEnabled = (): boolean =>
	String(process.env.REACT_APP_AUTOPILOT_ENABLED || '')
		.trim()
		.toLowerCase() === 'true';
